const configFunc = {

    HttpEndpoint: (path) => `${window.SCHEMA}://${window.ENDPOINT}${path}`,
    SocketEndpoint: (path) => `${window.WEBSOCKET_SCHEMA}://${window.ENDPOINT}${path}`,
    ResourceUrl: (path) => `${window.SCHEMA}://${window.ENDPOINT}/api/resource/${path}`
}

export default configFunc